import { Injectable } from '@angular/core';
import { InstantMeetingSettings } from './interfaces/service-interfaces';
import { MeetingSource, GoogleMeetMeetingAttendeeInterface } from '@vendasta/meetings';
import { convertAttendeeInfoToApiHeader } from '../elements/helpers/google-meet-helpers';
import { BaseMeetingService } from './base-meeting.service';
import { MeetingIntegrationsServiceModule } from '../meeting-integrations-service.module';

@Injectable({ providedIn: MeetingIntegrationsServiceModule })
export class GoogleMeetService extends BaseMeetingService {
  protected getAttendeesFromSettings(settings: InstantMeetingSettings): GoogleMeetMeetingAttendeeInterface[] {
    return convertAttendeeInfoToApiHeader(settings.attendees);
  }

  protected getMeetingSource(): MeetingSource {
    return MeetingSource.MEETING_SOURCE_GOOGLE_MEET;
  }
}
